@if (friend) {
  <div class="avatar">
    <app-avatar class="avatar-md w-24 flex-none mr-7"
                [url]="friend.avatar?.url ?? ''"
                [name]="friend.fullName"
    ></app-avatar>
  </div>
  <div
    [style.cursor]="friend.shareTo && friend.shareFrom ? 'pointer': 'default'"
    (click)="friend.shareFrom && friend.shareTo ? navigateToFriendScreen(friend.id) : null"
    class="user-info">
    <h3 class="name">{{ friend.fullName }}</h3>
    <p class="username"> {{ '@' + friend.userName }}</p>
  </div>
  @if (!selectBtn) {
    <div class="actions">
      <div [style.paddingRight]="friendOfFriend ? '10px': 0" class="icon">
        <app-icon size="medium" *ngIf="friend.shareTo === 'active' && friend.shareFrom !== 'active'"
                  name="arrowLeft"></app-icon>
        <app-icon size="medium" *ngIf="friend.shareFrom === 'active' && friend.shareTo !== 'active'"
                  name="arrowRight"></app-icon>
        <app-icon size="medium" *ngIf="friend.shareFrom === 'active' && friend.shareTo === 'active'"
                  name="arrowLeftRight"></app-icon>
      </div>
      @if (!friendOfFriend) {
        <div class="more">
          <app-friends-action-menu (eventTriggered)="onEvent($event)" [friend]="friend"></app-friends-action-menu>
        </div>
      }
    </div>
  } @else {
    <div class="actions">
      <mat-checkbox
        [checked]="selected"
        (change)="onCheckboxChange($event)"
        class="text-blue">
      </mat-checkbox>
    </div>
  }
}
